const en = {
  // General
  'Русский': 'Russian',
  'Английский': 'English',
  'Турецкий': 'Turkish',
  'Выход': 'Logout',
  'Пополнить': 'Top up',
  'Пополнение': 'Top up',
  'Сотрудники': 'Employees',
  'Шаблоны': 'Templates',
  'Email шаблоны': 'Email templates',
  'Push шаблоны': 'Push templates',
  'Статистика': 'Statistics',
  'Розыгрыш': 'Raffles',
  'Розыгрыши': 'Raffles',
  'Настройки': 'Settings',
  'Форма оплаты': 'Payment form',
  'Виджеты': 'Widgets',
  'Сообщения': 'Messages',
  'Акции': 'Promotions',
  'Win-back': 'Win-back',
  'Возвращение клиентов': 'Customer win-back',
  '50% от суммы платежа на баланс после 90 дней без успешных заказов': 'Credit 50% of the payment after 90 days without successful orders',
  'Акция включена': 'Promotion enabled',
  'Акция выключена': 'Promotion disabled',
  'История начислений': 'Reward history',
  'Предыдущий успешный заказ': 'Previous successful order',
  'Бонус': 'Reward',
  'Дата начисления': 'Reward date',
  'Начислений пока нет': 'No rewards yet',
  'Строк на странице': 'Rows per page',
  'Ошибка загрузки акции': 'Failed to load promotion',
  'Ошибка обновления статуса акции': 'Failed to update promotion status',
  'Система': 'System',
  'Отложенные заказы': 'Deferred orders',
  'Отправленные заказы': 'Submitted orders',
  'Язык интерфейса': 'Interface language',
  'Сменить язык': 'Change language',
  // Login
  'Вход в админ-панель': 'Admin login',
  'Логин': 'Login',
  'Войти': 'Sign in',
  'Неверный логин или пароль': 'Invalid login or password',
  'Ошибка авторизации': 'Authorization error',
  'Ошибка входа': 'Sign-in error',
  // Sidebar statuses
  '[Мои]': '[My]',
  'Новый': 'New',
  'Готово': 'Done',
  'Уточнения': 'Clarification',
  'Возврат': 'Refund',
  'Ожидание': 'Pending',
  'Ошибка': 'Error',
  // Orders table / dialogs
  'Загрузка...': 'Loading...',
  'Поиск...': 'Search...',
  'Найти заказ': 'Find order',
  'Найти': 'Find',
  'Введите номер заказа': 'Enter order number',
  'Платежная система': 'Payment system',
  'Сумма пополнения': 'Top-up amount',
  'Сумма платежа': 'Payment amount',
  'Способ оплаты': 'Payment method',
  'Дата создания': 'Created at',
  'Дополнительные поля': 'Additional fields',
  'Заказ не найден': 'Order not found',
  'Ошибка поиска заказа': 'Order search failed',
  'Нет доступа': 'Access denied',
  'Email': 'Email',
  'Email для отправки': 'Email for sending',
  'Оповестить пользователя о статусе': 'Notify user about status',
  'Отправка...': 'Sending...',
  'Письмо отправлено': 'Email sent',
  'Язык PDF': 'PDF language',
  'Скачать акт PDF': 'Download act PDF',
  'Генерация...': 'Generating...',
  'Акт PDF скачан': 'PDF act downloaded',
  'Ошибка скачивания PDF': 'PDF download failed',
  'Вид': 'View',
  'От': 'From',
  'До': 'To',
  'Дата и время оплаты': 'Paid at',
  'Номер заказа': 'Order #',
  'Номер заказа или пополнения': 'Order or top-up number',
  'Клиент': 'Customer',
  'Язык': 'Language',
  'Сервис': 'Service',
  'Номер пополнения': 'Top-up phone',
  'Введите номер пополнения': 'Enter top-up number',
  'Искать по номеру пополнения': 'Search by top-up number',
  'Результаты поиска': 'Search results',
  'Нет результатов по номеру пополнения': 'No results for top-up number',
  'Минимум 5 символов': 'Minimum 5 characters',
  'Пополняемая сумма': 'Top-up amount',
  'Статус': 'Status',
  'Оператор': 'Operator',
  'Действие': 'Action',
  'Примечание': 'Note',
  'Приз': 'Prize',
  'Дата': 'Date',
  'Нет данных': 'No data',
  'Нет результатов': 'No results',
  'Плотность': 'Density',
  'Компактно': 'Compact',
  'Стандартно': 'Standard',
  'Комфортно': 'Comfortable',
  'Столбцы': 'Columns',
  'Выбрать столбцы': 'Pick columns',
  'Фильтры': 'Filters',
  'Показать фильтры': 'Show filters',
  'Скрыть фильтры': 'Hide filters',
  'Экспорт': 'Export',
  'Скачать CSV': 'Download CSV',
  'Печать': 'Print',
  'Поиск столбца': 'Search column',
  'Название столбца': 'Column name',
  'Изменить порядок столбцов': 'Reorder columns',
  'Показать все': 'Show all',
  'Скрыть все': 'Hide all',
  'Сортировать по возрастанию': 'Sort ascending',
  'Сортировать по убыванию': 'Sort descending',
  'Сбросить сортировку': 'Clear sort',
  'Фильтр': 'Filter',
  'Скрыть': 'Hide',
  'Показать столбцы': 'Show columns',
  'Выбрать все': 'Select all',
  'Операторы': 'Operators',
  'И': 'AND',
  'ИЛИ': 'OR',
  'Значение': 'Value',
  'Значение фильтра': 'Filter value',
  'Меню': 'Menu',
  'Строк на странице:': 'Rows per page:',
  'Поиск столбцов': 'Search columns',
  'Поиск по билетам': 'Search tickets',
  'Билет, email или телефон': 'Ticket, email or phone',
  'Нет билетов для выбранной серии': 'No tickets for selected series',
  'Кликните для копирования': 'Click to copy',
  'Скопировано!': 'Copied!',
  'Взять': 'Take',
  'Уточнение для клиента': 'Clarification for client',
  'Сообщение клиенту': 'Message to client',
  'Причина возврата': 'Refund reason',
  'Настройки вида': 'View settings',
  'Закрыть': 'Close',
  'Редактировать примечание': 'Edit note',
  'Информация о заказе': 'Order info',
  'Отправить': 'Send',
  'Поиск по билетам:': 'Ticket search:',
  'Заполните корректно все обязательные поля': 'Fill in all required fields correctly',
  'Ошибка загрузки': 'Failed to load data',
  'Ошибка удаления': 'Failed to delete',
  'Ошибка обновления заказа': 'Failed to update order',
  // Dialogs
  'Отмена': 'Cancel',
  'Подтвердить': 'Confirm',
  'Сохранить': 'Save',
  'Сохранить и повторить': 'Save and retry',
  'Сохранение...': 'Saving...',
  // Orders
  'Ошибка загрузки заказов': 'Failed to load orders',
  'Ошибка загрузки заказов. Показаны тестовые данные.': 'Failed to load orders. Showing demo data.',
  'Выберите метод пополнения': 'Choose top-up method',
  'Активные заказы с отложенной более чем на 10 минут следующей попыткой': 'Active orders with the next attempt deferred by more than 10 minutes',
  'Период, часов': 'Period, hours',
  'Причина': 'Reason',
  'Все причины': 'All reasons',
  'Недостаточно баланса': 'Insufficient balance',
  'Ошибка обработчика': 'Worker error',
  'Ошибка провайдера': 'Provider error',
  'Ожидание провайдера': 'Waiting for provider',
  'Отложено системой': 'Deferred by system',
  'Показать': 'Show',
  'Ускорить обработку': 'Accelerate processing',
  'Ошибка загрузки отложенных заказов': 'Failed to load deferred orders',
  'Ошибка ускорения заказов': 'Failed to accelerate orders',
  'Ускорено заказов: {count}': 'Orders accelerated: {count}',
  'Найдено заказов за период: {count}': 'Orders found for the period: {count}',
  'Отложенных заказов за выбранный период нет': 'No deferred orders for the selected period',
  'Следующая попытка': 'Next attempt',
  'Можно ускорить': 'Can be accelerated',
  'Только просмотр': 'View only',
  'Ускорить обработку заказов?': 'Accelerate order processing?',
  'Ближайшему cron-запуску будут переданы заказы: {count}': 'Orders queued for the next cron run: {count}',
  'Будут ускорены только безопасные причины. Статусы и идентификаторы платежей не будут сброшены.': 'Only safe reasons will be accelerated. Payment statuses and identifiers will not be reset.',
  'Обработка...': 'Processing...',
  'Ускорить': 'Accelerate',
  'Заказы в обработке, уже отправленные провайдеру': 'Processing orders already submitted to the provider',
  'Ошибка загрузки отправленных заказов': 'Failed to load submitted orders',
  'Статус заказа проверен': 'Order status checked',
  'Ошибка проверки заказа': 'Failed to check order',
  'ID провайдера': 'Provider ID',
  'Последнее обновление': 'Last updated',
  'Отправленных заказов за выбранный период нет': 'No submitted orders for the selected period',
  'Проверка...': 'Checking...',
  'Проверить сейчас': 'Check now',
  // Raffles common
  'Билеты': 'Tickets',
  'Кратко': 'Overview',
  'Победитель': 'Winner',
  'Победители': 'Winners',
  'Продажи по месяцам': 'Monthly sales',
  'Серия': 'Series',
  'Билет': 'Ticket',
  'Телефон': 'Phone',
  'Цена': 'Price',
  'Дата покупки': 'Purchase date',
  'Нет данных для статистики': 'No data for statistics',
  'Победители пока не зарегистрированы.': 'No winners yet.',
  'Пока нет данных.': 'No data yet.',
  'Данные о текущем розыгрыше недоступны.': 'No current raffle data.',
  // Raffle stats
  'Всего билетов': 'Total tickets',
  // Raffle settings blocks
  'Цены на билеты': 'Ticket prices',
  'Добавить / обновить цену': 'Add / update price',
  'Количество билетов': 'Tickets count',
  'Доступные цены': 'Available prices',
  'Удалить': 'Delete',
  'Текущий розыгрыш': 'Current raffle',
  'Продано билетов': 'Tickets sold',
  'Цель по билетам': 'Ticket goal',
  'Название приза': 'Prize name',
  'Прогресс:': 'Progress:',
  'Новая цель по билетам': 'New ticket goal',
  'Обновить цель': 'Update goal',
  'Цель должна быть положительным целым числом': 'Goal must be a positive integer',
  'Нет доступа для обновления': 'No access to update',
  'Цель обновлена': 'Goal updated',
  'Ошибка загрузки данных о розыгрыше': 'Failed to load raffle data',
  'Ошибка обновления цели': 'Failed to update goal',
  'Не удалось загрузить серии': 'Failed to load series',
  'Ошибка загрузки серий': 'Failed to load series',
  'Не удалось загрузить билеты': 'Failed to load tickets',
  'Ошибка загрузки билетов': 'Failed to load tickets',
  'Не удалось загрузить победителя': 'Failed to load winner',
  'Ошибка загрузки победителя': 'Failed to load winner',
  'Не удалось загрузить статистику по дням': 'Failed to load daily stats',
  'Удалить цену': 'Delete price',
  'на': 'for',
  'билетов': 'tickets',
  'Цена сохранена': 'Price saved',
  'Цена удалена': 'Price deleted',
  'активная': 'active',
  'шт': 'pcs',
  'Продажи по дням': 'Sales by day',
  'Победитель ещё не определён.': 'Winner is not defined yet.',
  'Ошибка загрузки курса': 'Failed to load rate',
  // Users
  'Добавить пользователя': 'Add user',
  'Имя': 'Name',
  'Роль': 'Role',
  'Действия': 'Actions',
  'Доступ запрещён. Только для администратора.': 'Access denied. Admin only.',
  'Логин должен быть уникальным': 'Login must be unique',
  'Пользователь успешно создан': 'User created',
  'Пользователь удалён': 'User removed',
  'Удалить пользователя?': 'Delete user?',
  'Вы уверены, что хотите удалить этого пользователя? Это действие необратимо.': 'Are you sure? This action cannot be undone.',
  // Email templates
  'Нет изменений для сохранения': 'No changes to save',
  'Шаблоны успешно сохранены!': 'Templates saved',
  'Ошибка загрузки шаблонов': 'Failed to load templates',
  'Тема': 'Subject',
  'Заголовок': 'Title',
  'Вкл': 'On',
  'Выкл': 'Off',
  'Ошибка загрузки push шаблонов': 'Failed to load push templates',
  'Ошибка сохранения push шаблонов': 'Failed to save push templates',
  'Push шаблоны успешно сохранены!': 'Push templates saved',
  // Popup messages
  'Создать сообщение': 'Create message',
  'Редактировать сообщение': 'Edit message',
  'Удалить сообщение?': 'Delete message?',
  'Название': 'Name',
  'Размещение': 'Placement',
  'Приоритет': 'Priority',
  'Период показа': 'Display period',
  'Включено': 'Enabled',
  'до': 'to',
  'Начало показа': 'Display starts',
  'Окончание показа': 'Display ends',
  'Задержка (мс)': 'Delay (ms)',
  'Длительность (мс)': 'Duration (ms)',
  '0 — не закрывать автоматически': '0 — do not close automatically',
  'Максимум показов на браузер': 'Maximum impressions per browser',
  'Пусто или 0 — без ограничения': 'Empty or 0 — unlimited',
  'HTML сообщения': 'Message HTML',
  'Дополнительный CSS': 'Additional CSS',
  'Предпросмотр': 'Preview',
  'Предпросмотр сообщения': 'Message preview',
  'Предпросмотр изолирован: скрипты и доступ к странице отключены.': 'Preview is isolated: scripts and page access are disabled.',
  'Сообщений пока нет': 'No messages yet',
  'Укажите название сообщения': 'Enter a message name',
  'Добавьте HTML хотя бы для одного языка': 'Add HTML for at least one language',
  'Добавьте HTML на русском языке': 'Add the message HTML in Russian',
  'Дата окончания должна быть позже даты начала': 'End date must be after start date',
  'Сообщение создано': 'Message created',
  'Сообщение обновлено': 'Message updated',
  'Сообщение удалено': 'Message deleted',
  'Статус сообщения обновлён': 'Message status updated',
  'Ошибка загрузки сообщений': 'Failed to load messages',
  'Ошибка сохранения сообщения': 'Failed to save message',
  'Ошибка обновления статуса': 'Failed to update status',
  'Сообщение будет удалено без возможности восстановления.': 'The message will be permanently deleted.',
  // Settings
  'SMTP настройки': 'SMTP settings',
  'SMTP сервер': 'SMTP server',
  'Безопасность соединения': 'Connection security',
  'Без защиты': 'No encryption',
  'Порт': 'Port',
  'Пользователь': 'Username',
  'Настройки SMTP успешно сохранены!': 'SMTP settings saved',
  'Ошибка загрузки настроек': 'Failed to load settings',
  'Ошибка сохранения настроек': 'Failed to save settings',
  'Курс для сервисов': 'Rates for services',
  'Курс TMT': 'TMT rate',
  'Курс 1 TMT': '1 TMT rate',
  'Курс для внешних сервисов. TMCELL/ASTU/TurkmenTelecom/TMCELL GB.': 'Rates for external services. TMCELL/ASTU/TurkmenTelecom/TMCELL GB.',
  'Цена (USD)': 'Price (USD)',
  'Цена за 1 TMT в выбранной валюте': 'Price per 1 TMT in the selected currency',
  'Курс USD→TMT': 'USD→TMT rate',
  'Курс сохранён': 'Rate saved',
  'Введите положительное число': 'Enter a positive number',
  'Платёжные системы': 'Payment systems',
  'Ошибка загрузки платёжных систем': 'Failed to load payment systems',
  'Настройте способы оплаты, которые будут доступны в публичной форме': 'Configure payment methods available in the public form',
  'Добавить систему': 'Add system',
  'Нет платёжных систем': 'No payment systems',
  'Включена': 'Enabled',
  'Убрать': 'Remove',
  'Код': 'Code',
  'Код обязателен, уникален и может содержать a-z, 0-9, _ или -': 'Code is required, unique, and can contain a-z, 0-9, _ or -',
  'Например: sbp': 'Example: sbp',
  'Тип': 'Type',
  'Выберите тип': 'Select type',
  'СБП': 'SBP',
  'Карты': 'Cards',
  'Другое': 'Other',
  'Вес': 'Weight',
  'Введите число от 1 до 100': 'Enter a number from 1 to 100',
  'Для будущего распределения': 'For future distribution',
  'Название RU': 'Name RU',
  'Название EN': 'Name EN',
  'Название TM': 'Name TM',
  'Название TR': 'Name TR',
  'Обязательное поле': 'Required field',
  'Ссылка на изображение': 'Image URL',
  'Проверьте поля платёжных систем': 'Check payment system fields',
  'Ошибка сохранения платёжных систем': 'Failed to save payment systems',
  'Платёжные системы сохранены': 'Payment systems saved',
  'Отправка письма': 'Send email',
  'Email получателя': 'Recipient email',
  'Письмо успешно отправлено!': 'Email sent successfully',
  'Ошибка отправки письма': 'Failed to send email',
  'Ошибка отправки': 'Send error',
  'Текст': 'Body',
  'Загрузка': 'Loading',
  // Topup
  'Выберите провайдера': 'Choose provider',
  'Баланс': 'Balance',
  'Обновить баланс': 'Refresh balance',
  'Платежи': 'Payments',
  'ID заказа': 'Order ID',
  'Не удалось загрузить провайдеров': 'Failed to load providers',
  'Ошибка загрузки платежей': 'Failed to load payments',
  'Не удалось найти платеж': 'Payment not found',
  'Проверить': 'Check',
  'Платеж создан': 'Payment created',
  'Не удалось создать платеж': 'Failed to create payment',
  'Состояние': 'State',
  'Источник': 'Source',
  'Аккаунт': 'Account',
  'Сумма': 'Amount',
  'Выбрать': 'Select',
  'Пакеты': 'Packages',
  'Провайдер': 'Provider',
  // Statistics page
  'Сегодня': 'Today',
  '7 дней': '7 days',
  '30 дней': '30 days',
  'Всё время': 'All time',
  'Период': 'Custom period',
  'Янв': 'Jan',
  'Фев': 'Feb',
  'Мар': 'Mar',
  'Апр': 'Apr',
  'Май': 'May',
  'Июн': 'Jun',
  'Июл': 'Jul',
  'Авг': 'Aug',
  'Сен': 'Sep',
  'Окт': 'Oct',
  'Ноя': 'Nov',
  'Дек': 'Dec',
  'Ошибка загрузки статистики': 'Failed to load statistics',
  'Обновить': 'Refresh',
  'Управление кэшем': 'Cache management',
  'По месяцам:': 'By months:',
  'Сбросить': 'Reset',
  'Кэш активен': 'Cache is active',
  'Кэш пуст': 'Cache is empty',
  'Закэшировано дней:': 'Cached days:',
  'Последнее обновление:': 'Last rebuild:',
  'Идёт сборка...': 'Rebuilding...',
  'Полная пересборка:': 'Full rebuild:',
  'Данные из кэша (последние {days} дня считаются в реальном времени)': 'Data from cache (last {days} days are live)',
  'Данные рассчитаны в реальном времени (кэш не использован)': 'Data calculated in real time (cache not used)',
  'Обновить кэш': 'Rebuild cache',
  'Обработано дней:': 'Processed days:',
  'Время:': 'Duration:',
  'Не удалось загрузить статус кэша. Возможно, таблицы кэша ещё не созданы.': 'Failed to load cache status. Cache tables may be missing.',
  'Доход': 'Revenue',
  'Раздел в разработке': 'Section in progress',
  'Всего заказов': 'Total orders',
  'Билетов продано': 'Tickets sold',
  'Уникальных клиентов': 'Unique clients',
  'Конверсия': 'Conversion',
  'Доход по валютам': 'Revenue by currency',
  'Динамика дохода': 'Revenue trend',
  'По способу оплаты': 'By payment method',
  'По сервисам': 'By services',
  'Успешность заказов по сервисам': 'Order success by service',
  'Детализация по валютам': 'Currency breakdown',
  'Нет данных для отображения': 'No data to display',
  'из': 'of',
  'Клиенты': 'Clients',
  'Все клиенты': 'All clients',
  'Неактивные клиенты': 'Inactive clients',
  'Месяцев без успешных заказов': 'Months without successful orders',
  'Введите целое число месяцев от 1 до 120': 'Enter a whole number of months from 1 to 120',
  'Ошибка загрузки неактивных клиентов': 'Failed to load inactive clients',
  'Показаны клиенты, у которых последний успешный платеж был раньше выбранного периода.': 'Clients whose last successful payment was before the selected period.',
  'Дата последнего заказа': 'Last order date',
  'Неактивные клиенты не найдены': 'No inactive clients found',
  'CSV выгружен': 'CSV downloaded',
  'Ошибка выгрузки CSV': 'CSV download failed',
  'Операция': 'Adjust',
  'Операция с балансом': 'Balance adjustment',
  'Текущий баланс': 'Current balance',
  'Сумма операции': 'Adjustment amount',
  'После пополнения': 'Balance after top-up',
  'После списания': 'Balance after deduction',
  'недостаточно средств': 'insufficient funds',
  'Списать': 'Deduct',
  'Введите сумму больше нуля': 'Enter an amount greater than zero',
  'Сумма списания превышает текущий баланс': 'The deduction exceeds the current balance',
  '1 строка выбрана': '1 row selected',
  '{count} строки выбраны': '{count} rows selected',
  '{count} строк выбрано': '{count} rows selected',
  'Всего строк:': 'Total rows:',
  'Заказы: {count}': 'Orders: {count}',
  'Билетов: {count}': 'Tickets: {count}',
  'Не удалось загрузить статус кэша': 'Failed to load cache status',
  'Конверсия оплат': 'Payment conversion',
  'Оплачено vs Не оплачено': 'Paid vs Unpaid',
  'Оплачено': 'Paid',
  'Не оплачено': 'Unpaid',
  'В обработке': 'Processing',
  'Отменено': 'Cancelled',
  'Конверсия по сервисам': 'Conversion by services',
  'Оплачено: {done} из {all}': 'Paid: {done} of {all}',
  'потеряно': 'lost',
  'Валюта': 'Currency',
  'Заказов': 'Orders count',
  'Пополнено (TMT)': 'Top-up (TMT)',
  'Билетов': 'Tickets',
};

export default en;

